import request from '@/utils/request'

let UserApi = {

  /*用户登录*/
  login(data, errorback) {
    return request._post('/supplier/passport/login', data, errorback);
  },
  saasLogin (data, errorback) {
    return request._post('/supplier/passport/saasLogin', data, errorback);
  },
  /*退出登录*/
  loginOut(data, errorback) {
    return request._post('/supplier/passport/logout', data, errorback);
  },
  /*修改密码*/
  EditPass(data, errorback) {
    return request._post('/supplier/passport/editPass', data, errorback);
  },
  /*获取图片验证码*/
  getCodeImg(data, errorback) {
    return request._get('/supplier/captcha/image', data, errorback);
  },
  /*获取短信验证码*/
  getCodeSms(data, errorback) {
    return request._postBody('/supplier/captcha/sms', data, errorback);
  },
  /*检验用户名称是否存在*/
  checkExistName(data, errorback) {
    return request._get('/supplier/passport/checkLoginName', data, errorback);
  },
  /*申请账号*/
  applyUser(data, errorback) {
    return request._postBody('/supplier/passport/applyUser', data, errorback);
  },
  /*重置密码*/
  resetPassword(data, errorback) {
    return request._postBody('/supplier/passport/resetPassword', data, errorback);
  },
  /*充值*/
  userRecharge (data, errorback) {
    return request._postBody('/supplier/user/recharge', data, errorback);
  },
  /*删除用户*/
  deleteuser (data, errorback) {
    return request._post('/supplier/user/delete', data, errorback);
  },
  /*用户列表*/
  userlist (data, errorback) {
    return request._postBody('/supplier/user/index', data, errorback);
  },
  /*等级列表*/
  gradelist (data, errorback) {
    return request._postBody('/supplier/user/grade/index', data, errorback);
  },
  /*等级列表*/
  gradelog (data, errorback) {
    return request._postBody('/supplier/user/grade/log', data, errorback);
  },
  /*添加等级*/
  addgrade (data, errorback) {
    return request._postBody('/supplier/user/grade/add', data, errorback);
  },
  /*修改等级*/
  editGrade (data, errorback) {
    return request._postBody('/supplier/user/grade/edit', data, errorback);
  },
  /*删除等级*/
  deletegrade (data, errorback) {
    return request._post('/supplier/user/grade/delete', data, errorback);
  },
  /*用户余额*/
  BalanceLog (data, errorback) {
    return request._postBody('/supplier/user/balance/index', data, errorback);
  },
  /*充值记录*/
  RechargeOrder (data, errorback) {
    return request._post('/supplier/user.Recharge/order', data, errorback);
  },
  /*用户标签*/
  toEditTag (data, errorback) {
    return request._get('/supplier/user/toEditTag', data, errorback);
  },
  /*用户标签*/
  editTag (data, errorback) {
    return request._postBody('/supplier/user/editTag', data, errorback);
  },
  /*用户角色*/
  toEditRole (data, errorback) {
    return request._get('/supplier/user/toEditRole', data, errorback);
  },
  /*用户标签*/
  editRole (data, errorback) {
    return request._postBody('/supplier/user/editRole', data, errorback);
  },

  /*提现记录*/
  cashList(data, errorback) {
    return request._postBody('/supplier/user/cash/index', data, errorback);
  },
  /*提现审核*/
  cashSubmit(data, errorback) {
    return request._postBody('/supplier/user/cash/submit', data, errorback);
  },
  /*提现确认打款*/
  cashMoney(data, errorback) {
    return request._post('/supplier/user/cash/money', data, errorback);
  },
  /*用户角色*/
  tree (data, errorback) {
    return request._get('/supplier/user/tree', data, errorback);
  },
}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js